import React from "react";
import { useTranslation } from "react-i18next";
import { ServiceTypeSelectorOption } from "../../../../../../src/types/order";

type BookingSummaryNoteProps = {
  serviceType: ServiceTypeSelectorOption;
};
function BookingSummaryNote({ serviceType }: BookingSummaryNoteProps) {
  const { t } = useTranslation();
  const isApartment = serviceType === ServiceTypeSelectorOption.APARTMENT;

  return (
    <div className="bg-[#EDF0F5] rounded p-2 text-sm mb-2 w-full">
      <span className="font-bold">{t("orders.ticket_overview.apartment_overview_note.nb")}</span>{" "}
      {isApartment
        ? t("orders.ticket_overview.apartment_overview_note.content")
        : t("orders.ticket_overview.generic_note.content")}
    </div>
  );
}

export default BookingSummaryNote;
